/* eslint-disable @typescript-eslint/naming-convention */
export class RichTextEditorDefaultStylesModel {
    [key: string]: string;
    color: string;
    'font-family': string;
    'font-size': string;
    'font-weight': string;
    'font-style': string;
    'text-decoration': string;
    'text-align': string;
}
